// ====================================================================================
// swiper.module
// ====================================================================================
import Swiper from "swiper";
import { Navigation, Pagination, A11y, Keyboard } from "swiper/modules"; // Pagination, Scrollbar

export const init = function () {
  const swiperContainers = document.querySelectorAll(".swiper-container--2");

  swiperContainers.forEach(function (slider) {
    let cID = slider.getAttribute("id");
    let slidesLength = slider.querySelectorAll(".swiper-slide").length;

    let swiper = new Swiper(`#${cID}`, {
      modules: [Navigation, Pagination, Keyboard, A11y],
      lazy: true,
      loop: true,
      speed: 500,
      slidesPerView: 1,
      enabled: slidesLength > 1 ? true : false,
      pagination: {
        el: `#${cID} .swiper-pagination`,
        clickable: true,
        renderBullet: function (index, className) {
          return `<span class="${className} dot">${index}</span>`;
        },
      },
      a11y: {
        prevSlideMessage: "Vorherige Folie",
        nextSlideMessage: "Nächste Folie",
      },
      navigation: {
        prevEl: `#${cID} .swiper-button-prev`,
        nextEl: `#${cID} .swiper-button-next`,
      },
      keyboard: { enabled: true },
      a11y: { enabled: true },
      on: {
        afterInit: function (swiper) {
          document.querySelector(`#${cID}`).classList.add("slider-init");
          if (swiper.enabled) {
            document.querySelector(`#${cID}`).classList.remove("slider-lock");
          } else {
            document.querySelector(`#${cID}`).classList.add("slider-lock");
          }
          swiper.updateSize();
          swiper.updateSlides();
        },
        lock: function () {
          document.querySelector(`#${cID}`).classList.add("slider-lock");
        },
        unlock: function () {
          document.querySelector(`#${cID}`).classList.remove("slider-lock");
        },
        beforeSlideChangeStart: function (swiper) {
          let slide = swiper.slides[swiper.activeIndex];
          let tooltips = slide.querySelectorAll('[data-bs-toggle="tooltip"].open');
          tooltips.forEach(function (tooltip) {
            tooltip.click();
          });
        },
      },
    });

    swiper.updateSize();
    swiper.updateSlides();
  });
};
